import React from 'react';
import { FormControl, FormHelperText, TextField, TextFieldProps } from '@mui/material';

export type TextInputProps = Omit<
  TextFieldProps,
  'onChange' | 'label' | 'error' | 'autocomplete'
> & {
  label: string;
  onChange: (name: string, value: string) => void;
  error?: string | undefined;
  size?: string;
  width?: string;
};

const TextInput: React.FC<TextInputProps> = ({
  name,
  label,
  placeholder,
  onChange,
  variant = 'outlined',
  disabled = false,
  error = null,
  size = 'small',
  width,
  ...props
}) => {
  const handleChange = e => {
    const { name, value } = e.target;
    return onChange(name, value);
  };

  return (
    <FormControl variant="standard" fullWidth>
      <FormHelperText sx={{ fontWeight: '400', color: 'black !important', fontSize: '12px' }}>
        {label}
      </FormHelperText>
      <TextField
        name={name}
        key={`${name}_input`}
        placeholder={placeholder}
        autoComplete="off"
        variant={variant}
        size={size}
        onChange={handleChange}
        error={Boolean(error)}
        helperText={error}
        inputProps={{
          'aria-label': label,
          border: '2px solid'
        }}
        {...(disabled && { disabled })}
        {...props}
      />
    </FormControl>
  );
};

export default TextInput;
